export const namespace = 'managementReports'
